import React from 'react';
import {array} from 'prop-types';
import styled from 'styled-components';
import {SIZES, Typography} from '@fupa/fupa-uikit';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 13rem;
`;

const ScalingTypography = styled(Typography)`
  &&& {
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['16']};
    }
  }
`;

const Information = ({content}) => {
  return (
    <Wrapper>
      <ScalingTypography variant='body1'>{content}</ScalingTypography>
    </Wrapper>
  );
};

Information.propTypes = {
  content: array.isRequired,
};

export {Information};
